import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

type OverageService = {
  getOverages: (date: string, ids?: string[]) => ApiPromise;
  getOrganizationOverages: (id: number, date: string) => ApiPromise;
};

const resource = 'overages';

const joinOrganizationIds = (organizations: string[]) => {
  return organizations.length
    ? `&${organizations.map((organization) => `organizations[]=${organization}`).join('&')}`
    : '';
};

export const OverageService: OverageService = {
  getOverages: (date: string, ids: string[] = []) => {
    const orgIdParams = ids.length > 0 ? joinOrganizationIds(ids) : '';
    return HTTP.get(`${resource}/all?date=${date}${orgIdParams}`);
  },
  getOrganizationOverages: (id: number, date: string) => {
    return HTTP.get(`${resource}/${id}/list?date=${date}`);
  },
};
